(function() {
	'use strict';

	angular
		.module('assetCommon')
		.factory('geometryUtility', geometryUtility);

	function geometryUtility() {
		function getBestFitForConstraint(constraintWidth, constraintHeight, width, height) {
			if (!constraintHeight && !constraintWidth)
				return { width: width, height: height };

			var bounds, displayWidth, displayHeight;
			var constraintAspectRatio = constraintWidth / constraintHeight;
			var aspectRatio = width / height;

			if (constraintWidth && (!constraintHeight || (aspectRatio > constraintAspectRatio))) {
				displayWidth = Math.min(width, constraintWidth);
				bounds = {
					width: displayWidth,
					height: displayWidth / aspectRatio
				};
			}
			else {
				displayHeight = Math.min(height, constraintHeight);
				bounds = {
					width: displayHeight * aspectRatio,
					height: displayHeight
				};
			}

			return bounds;
		}

		return {
			getBestFitForConstraint: getBestFitForConstraint
		};
	}
})();